import Vue from 'vue'
import Router from 'vue-router'
import Staff from './views/Staff.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'staff',
			component: Staff,
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/staff-new',
			name: 'staff-new',
			component: () => import('./views/StaffEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/staff-edit/:staffId',
			name: 'staff-edit',
			component: () => import('./views/StaffEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/team',
			name: 'team',
			component: () => import('./views/Team.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/team-new',
			name: 'team-new',
			component: () => import('./views/TeamEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/team-edit/:teamId',
			name: 'team-edit',
			component: () => import('./views/TeamEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/coin',
			name: 'coin',
			component: () => import('./views/Coin.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/coin-new',
			name: 'coin-new',
			component: () => import('./views/CoinEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/coin-edit/:coinId',
			name: 'coin-edit',
			component: () => import('./views/CoinEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/present-list',
			name: 'present-list',
			component: () => import('./views/PresentList.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/present-edit/:presentCoinId',
			name: 'present-edit',
			component: () => import('./views/PresentEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/news',
			name: 'news',
			component: () => import('./views/News.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/category',
			name: 'category',
			component: () => import('./views/Category.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/category-new',
			name: 'category-new',
			component: () => import('./views/CategoryEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/category-edit/:categoryId',
			name: 'category-edit',
			component: () => import('./views/CategoryEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/prize',
			name: 'prize',
			component: () => import('./views/Prize.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/prize-new',
			name: 'prize-new',
			component: () => import('./views/PrizeEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/prize-edit/:prizeId',
			name: 'prize-edit',
			component: () => import('./views/PrizeEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/prize-exchange-history',
			name: 'prize-exchange-history',
			component: () => import('./views/PrizeExchangeHistory.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/information',
			name: 'information',
			component: () => import('./views/Information.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/information-new',
			name: 'information-new',
			component: () => import('./views/InformationEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/information-edit/:informationId',
			name: 'information-edit',
			component: () => import('./views/InformationEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/site-setting',
			name: 'site-setting',
			component: () => import('./views/SiteSetting.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/summary',
			name: 'summary',
			component: () => import('./views/Summary.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/output',
			name: 'output',
			component: () => import('./views/Output.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/preset',
			name: 'preset',
			component: () => import('./views/Preset.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/preset-new',
			name: 'preset-new',
			component: () => import('./views/PresetEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/preset-edit/:presetId',
			name: 'preset-edit',
			component: () => import('./views/PresetEdit.vue'),
			meta: {
				requireAuth: true,
			},
		},
		//{
		//	path: '/tables',
		//	name: 'tables',
		//	// route level code-splitting
		//	// this generates a separate chunk (about.[hash].js) for this route
		//	// which is lazy-loaded when the route is visited.
		//	component: () => import(/* webpackChunkName: "tables" */ './views/Tables.vue')
		//},
		//{
		//	path: '/forms',
		//	name: 'forms',
		//	component: () => import(/* webpackChunkName: "forms" */ './views/Forms.vue')
		//},
		//{
		//	path: '/profile',
		//	name: 'profile',
		//	component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue')
		//},
		//{
		//	path: '/client/new',
		//	name: 'client.new',
		//	component: () => import(/* webpackChunkName: "client-form" */ './views/ClientForm.vue'),
		//	//meta: {
		//	//	requireAuth: true,
		//	//	permitted: [1,3],
		//	//},
		//},
		//{
		//	path: '/client/:id',
		//	name: 'client.edit',
		//	component: () => import(/* webpackChunkName: "client-form" */ './views/ClientForm.vue'),
		//	props: true
		//},
		{
			path: 'full-page',
			component: () => import(/* webpackChunkName: "full-page" */ './views/FullPage.vue'),
			children: [
				{
					path: '/login',
					name: 'login',
					component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/Login.vue')
				},
				//{
				//	path: '/password-recovery',
				//	name: 'password-recovery',
				//	component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/PasswordRecovery.vue')
				//},
				//{
				//	path: '/error-in-card',
				//	name: 'error-in-card',
				//	component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/Error.vue')
				//},
				//{
				//	path: '/error-simple',
				//	name: 'error-simple',
				//	component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/Error.vue'),
				//	props: {isInCard: false}
				//},
				//{
				//	path: '/lock-screen',
				//	name: 'lock-screen',
				//	component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/LockScreen.vue'),
				//}
			]
		}
	],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
})

router.beforeEach((to, from, next) => {
	//console.log(to);
	//let isNext = false;
	if (to.matched.some(record => record.meta.requireAuth)) {
		// 認証トークン存在チェック
		if (!store.state.auth || !store.state.auth.token) {
			//console.log('login');
			next({ path: '/login' });
		}

		// アクセス権限チェック
		//console.log('check1');
		//to.matched.some(record => {
		//	//console.log('check2');
		//	let permissions = store.state.auth.permissions;
		//	for (var p of record.meta.permitted) {
		//		//console.log('p = '+p);
		//		for (let p2 of permissions) {
		//			//console.log('p2 = '+p2);
		//			if (p === p2) {
		//				//console.log('next1');
		//				isNext = true;
		//			}
		//		}
		//	}

		//	if (!isNext) {
		//		next({ path: '/' });
		//	}
		//});
	}

	next();
})

export default router;
